import type { MemberFilter as MemberFilterValue } from "../api/client";

export type MemberFilterProps = {
  value: MemberFilterValue;
  onChange: (value: MemberFilterValue) => void;
};

const options: Array<{ value: MemberFilterValue; label: string }> = [
  { value: "all", label: "全部" },
  { value: "member", label: "會員專享" },
  { value: "public", label: "一般文章" }
];

export function MemberFilter({ value, onChange }: MemberFilterProps) {
  return (
    <div className="segmented" role="tablist" aria-label="文章類型">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={value === option.value ? "active" : ""}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
